/**
 * /**
 *  * Auto-generated by Orval
 *  * OpenAPI spec: Auto-Playlist V2 API v1.0.0
 *  * DO NOT EDIT MANUALLY
 *  *\/
 *
 */

/**
 * * `image` - 이미지
 * `video` - 영상
 */
export type MediaTypeEnum = (typeof MediaTypeEnum)[keyof typeof MediaTypeEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const MediaTypeEnum = {
  image: "image",
  video: "video",
} as const;
